import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as PrinterIcon} from "assets/img/printer.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {OMSRoutes} from "utils/OMSRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function PrintersItem(props) {
    const {currentPath, currentMemberAuthorizations, currentOrganization} = useContext(SidebarContext);

    if (!hasAuthorization(currentMemberAuthorizations, Authorizations.PICKING_PRINTERS)
        || !currentOrganization?.printNodeKey
    ) {
        return null;
    }

    const isSelected = currentPath.startsWith(OMSRoutes.PRINTERS);

    return (
        <SidebarItem
            isTopLevel
            icon={<PrinterIcon />}
            to={OMSRoutes.PRINTERS}
            selected={isSelected}
        >
            <FormattedMessage id='sidebar.item.printer' />
        </SidebarItem>
    );
}

export default PrintersItem;
